export default function () {

  $(document).on('ready', function() {

    // Hero Slider
    var $heroSlick = $('.hero-slider');

    $heroSlick.slick( {
      infinite: true,
      speed: 800,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true,
    });

	});

  $(document).on('ready', function() {
    // Product Gallery Slider

    $('.product__image-gallery').slick( {
      infinite: true,
      speed: 800,
      fade: true,
      cssEase: 'linear',
      autoplay: false,
      arrows: false,
    });

    $('.prev-product-img').click(function() {
      $('.product__image-gallery').slick('slickPrev');
    });

    $('.next-product-img').click(function() {
      $('.product__image-gallery').slick('slickNext');
    });
  });

  $(document).on(
    'open.zf.reveal', '[data-reveal]', function () {
      // Refresh Slick so it shows once modal is shown
      setTimeout(function() {
        $('.product__image-gallery').slick("refresh");
      },400);
    }
  );

  $(document).on(
    'closed.zf.reveal', '[data-reveal]', function () {
      // Refresh Slick so it shows once modal is shown
      setTimeout(function() {
        $('.product__image-gallery').slick("unslick");
      },400);
    }
  );

  $(document).on('ready', function() {
    // Product Gallery Slider

    $('.best-sellers__carousel').slick( {
      infinite: true,
      speed: 800,
      fade: true,
      cssEase: 'linear',
      autoplay: false,
      arrows: false,
    });

    $('.best-sellers__prev-slide').click(function() {
      $('.best-sellers__carousel').slick('slickPrev');
    });

    $('.best-sellers__next-slide').click(function() {
      $('.best-sellers__carousel').slick('slickNext');
    });
  });

}



// WEBPACK FOOTER //
// ./scripts/components/SetupSlider.js